import React, { Fragment } from 'react'
import styled from 'styled-components'
import messages from '@App/session/messages'
import { useIntl } from 'react-intl'
import { sharedMessages as commonMessages, sharedMessages } from '@Locales/index'
import { HelperText, SignInFormButton, Warning } from '../../index'
import { ButtonLink } from '@Components/Button'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'
import { HubInput } from 'src/common/rtl/HubWidgets'

type props = {
  emailAddress: string
  hubName: string
  resetAction: () => void
  handlePasswordSubmit: (password: string) => void
  password: string
  handleSignIn: () => Promise<void>
  isAuthorized: boolean
}

const RequestEmail = (props: props) => {
  const {
    emailAddress,
    hubName,
    resetAction,
    handlePasswordSubmit,
    password,
    handleSignIn,
    isAuthorized,
  } = props
  const intl = useIntl()

  return (
    <Fragment>
      {!isAuthorized ? (
        <Warning>
          <HubFormattedMessage {...sharedMessages.signInError} />
        </Warning>
      ) : (
        <HelperText>
          <HubFormattedMessage
            {...messages.hubPasswordFormInstruction}
            values={{ hubName: <b>{hubName}</b> }}
          />
        </HelperText>
      )}
      <CurrentEmail>
        {emailAddress}
        <ChangeEmailLink onClick={resetAction}>
          <HubFormattedMessage {...commonMessages.change} />
        </ChangeEmailLink>
      </CurrentEmail>
      <PasswordInput
        type="password"
        aria-label={intl ? intl.formatMessage(commonMessages.password) : ''}
        placeholder={intl ? intl.formatMessage(commonMessages.password) : ''}
        name="Password"
        required
        autoFocus
        value={password}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePasswordSubmit(e.target.value)}
      />
      <SignInFormButton displayType="primary" onClick={handleSignIn}>
        <HubFormattedMessage {...commonMessages.signIn} />
      </SignInFormButton>
    </Fragment>
  )
}

const CurrentEmail = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmaller};
  margin: 20px 0;
  color: black;
`

const ChangeEmailLink = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.linkedin};
  margin-left: 10px;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`

const PasswordInput = styled(HubInput)`
  width: 100%;
  border-radius: 3px;
  border: ${({ theme }) => theme.colors.grayLight} 1px solid;
  padding: ${({ theme }) => theme.sizes.gutterSmall};

  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryAccentColor};
  }
`

export default RequestEmail
